export default {"src":"/_next/static/media/veri.1e04c641.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};